import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
    tone?: 'onDark' | 'onLight'
}

interface LogoProps {
    className?: string
    tone?: 'onDark' | 'onLight'
}

// The mark: a "G" drawn as a route that ends in a station, the network motif of the whole identity.
export const LogoMark: FC<LogoMarkProps> = ({ className, tone = 'onDark' }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            aria-hidden='true'
            focusable='false'
            className={cn('shrink-0', className)}
        >
            <path
                d='M22.9 10.2A9 9 0 1 0 25 16h-6.4'
                fill='none'
                stroke='currentColor'
                strokeWidth='3.2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />

            <circle
                cx='16.4'
                cy='16'
                r='2.9'
                className={tone === 'onDark' ? 'fill-signal-400' : 'fill-signal-600'}
            />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, tone = 'onDark' }): ReactNode => {
    return (
        <span className={cn('flex items-center gap-2.5', className)}>
            <LogoMark tone={tone} className='size-8' />

            <span className='font-heading stretch-wide text-[0.9rem] leading-none tracking-[0.08em] uppercase'>
                <span className='font-semibold'>
                    Gashi
                </span>

                {' '}

                <span className='font-normal opacity-75'>
                    Holding
                </span>
            </span>
        </span>
    )
}
